import React from "react"
import ReactDom from "react-dom"
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Link,
  withRouter,
  Switch
} from "react-router-dom"
import { Provider, connect } from "react-redux"
import {
  GearIcon,
  CrownIcon,
  HomeIcon,
  TripIcon,
  ReportIcon,
  CoinIcon,
  CarIcon,
  AccountantIcon,
  CompanyIcon
} from "../core/icons"
import { Badge, Tooltip } from "antd"
import "./SideNav.css"
import styled from "styled-components"

const NavRow = styled.div`
  display: flex;
  flex-direction: row !important;
  .ant-scroll-number-only > p {
    height: 10px;
  }
  .ant-badge-not-a-wrapper .ant-badge-count {
    top: 5px;
    left: -10px;
    background: rgb(255, 81, 102);
  }
`
// https://reacttraining.com/react-router/web/example/custom-link
const IconLink = ({
  label,
  to,
  activeOnlyWhenExact,
  icon: Icon,
  activeColor = "#31B59F",
  disabled,
  target
}) => (
  <Route
    path={to}
    exact={activeOnlyWhenExact}
    children={({ match }) => (
      <div className={match ? "active" : ""}>
        <Link
          style={disabled ? { color: "#96A2C2", fontStyle: "italic" } : null}
          disabled={disabled}
          target={target}
          to={to}
        >
          {match ? <Icon color={activeColor} /> : <Icon />}
          <span>{label}</span>
        </Link>
      </div>
    )}
  />
)

const mapStateToProps = ({ models: { user }, trips, transactions }) => ({
  ...user,
  // TODO move up to reducer:
  userBelongsToGroup:
    !!user.group_as_client ||
    !!user.group_as_enterprise_member ||
    !!user.group_as_enterprise_owner,
  unclassifiedTrips: trips.unclassified,
  unclassifiedTxns: transactions.unclassified
})

const SideNav = connect(mapStateToProps)(
  ({
    isEnterpriseOwner,
    isEnterpriseMember,
    isFetching,
    userBelongsToGroup,
    unclassifiedTrips,
    unclassifiedTxns
  }) => (
    <div className="SideNav">
      <IconLink to="/dashboard" label="Home" icon={HomeIcon} />
      <IconLink
        to="/premium"
        label="Premium"
        icon={CrownIcon}
        activeColor="#31B59F"
      />
      <hr />
      <NavRow>
        <IconLink to="/trips" label="Trips" icon={CarIcon} />
        <Tooltip title={`You have ${unclassifiedTrips} unclassified trips`}>
          <Badge overflowCount={9999} count={unclassifiedTrips} />
        </Tooltip>
      </NavRow>

      <NavRow>
        <IconLink to="/transactions" label="Transactions" icon={CoinIcon} />
        <Tooltip
          title={`You have ${unclassifiedTxns} unclassified transactions`}
        >
          <Badge overflowCount={9999} count={unclassifiedTxns} />
        </Tooltip>
      </NavRow>

      <IconLink to="/data-exports" label="Data Exports" icon={ReportIcon} />
      {!isEnterpriseMember && <hr />}
      {isEnterpriseOwner && (
        <IconLink
          to="/teams/members"
          label="Teams Dashboard"
          icon={AccountantIcon}
        />
      )}
      {!isFetching &&
        !isEnterpriseOwner &&
        !isEnterpriseMember && (
          <IconLink
            to="/accountants"
            label="Accountants"
            icon={AccountantIcon}
          />
        )}

      {!userBelongsToGroup &&
        !isFetching && (
          <IconLink
            // target="_blank"
            // to="https://everlance.com/teams"
            to="/teams-features"
            label="Teams Dashboard"
            icon={AccountantIcon}
          />
        )}
    </div>
  )
)

export default SideNav



// WEBPACK FOOTER //
// ./src/layout/SideNav.js